import { Skeleton } from 'antd';
import { observer } from 'mobx-react-lite';
import MultipleTaskSearchItem from './search-item';
import MultipleTaskSearchItemModal from './modal';


const CardMultipleTaskSearch = ({ data }) => {
  if (!data?.length) {
    return (
      <div className="flex flex-col h-400px items-center justify-center">
        <img
          className="w-190px"
          src="https://p5.ssl.qhimg.com/t11098f6bcda6a604f3f799138d.png"
        />
        <div className="text-14px leading-30px text-black text-opacity-50">
          调用工具失败
        </div>
      </div>
    );
  }

  if (!data[0]?.imageData?.url) {
    return <Skeleton className="p-20px" active />;
  }

  return (
    <>
      <MultipleTaskSearchItemModal data={data} />
      <div className={['overflow-hidden rounded-10px', 'flex flex-col']}>
        <div className="px-20px mx-4px my-16px pb-20px overflow-y-scroll scrollbar">
          {data.map((item, index) => {
            return (
              <MultipleTaskSearchItem key={index + item.buTaskId} item={item} />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default observer(CardMultipleTaskSearch);
